import { render, staticRenderFns } from "./MovingTesting.vue?vue&type=template&id=f8ed144a"
import script from "./MovingTesting.vue?vue&type=script&lang=ts"
export * from "./MovingTesting.vue?vue&type=script&lang=ts"
import style0 from "./MovingTesting.vue?vue&type=style&index=0&id=f8ed144a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports